import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store, { persistor } from "./lib/redux/store";
import { PersistGate } from "redux-persist/lib/integration/react";
import FullPageLoader from "./lib/common/components/loader/FullPageLoader";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { customTheme } from "./custom-theme";


import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

const nonce = document.querySelector("meta[property='csp-nonce']")?.getAttribute("content");

const cache = createCache({
  key: "mui",        
  prepend: true,      
  nonce: nonce ?? undefined, 
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <CacheProvider value={cache}>
    <Provider store={store}>
      <PersistGate loading={<FullPageLoader />} persistor={persistor}>
        <ThemeProvider theme={customTheme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </CacheProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
